(function () {
    'use strict';

    angular
        .module('app.campaignViewContract',[])
        .factory('campaignViewContractService', ['$q', '$http', '$rootScope', 'CampaignFormService', 'advertisersManagementService',
            function ($q, $http, $rootScope, CampaignFormService, advertisersManagementService) {
                function checkResponse(data) {
                  return data;
                }

                function getMessage(data) {
                  if (data) {
                    return data.message;
                  }
                  return false;
                }

                function handleRequest(url, method, params, loader) {
                    var deferred = $q.defer();

                    var req = {
                        url: url,
                        method: method,
                        data: JSON.stringify(params),
                        loader: loader
                    }

                    $http(req)
                        .success(function (data) {
                        var dataRes = angular.fromJson(data);

                        if (checkResponse(dataRes)) {
                            deferred.resolve(dataRes);
                        } else {
                            deferred.reject(getMessage(dataRes));
                        }
                    })
                    .error(function (error, status) {
                        error = error || {};
                        error.status = status;
                        deferred.reject(error);
                    });

                    return deferred.promise;
                }

                function getContractTermsForInfluencer(campaignId, campaignInfluencerId, loader) {
                    var url = $rootScope.apiUrl + 'campaign/' + campaignId + '/getContractTerms/' + campaignInfluencerId;
                    return handleRequest(url, 'GET', null, loader);
                }

                function getInfluencer(influencerId, loader) {
                    var url = $rootScope.apiUrl + 'admin/getInfluencerById/' + influencerId;
                    return handleRequest(url, 'GET', null, loader);
                }

                return {
                    getCampaign: CampaignFormService.getCampaign,
                    getAdvertiser: advertisersManagementService.getAdvertiser,
                    getContractTermsForInfluencer: getContractTermsForInfluencer,
                    getInfluencer: getInfluencer,
                };
            }
        ]);
})();
